import { render, staticRenderFns } from "./DecisionAiCoachList.vue?vue&type=template&id=ae1e5f40&scoped=true"
import script from "./DecisionAiCoachList.vue?vue&type=script&lang=js"
export * from "./DecisionAiCoachList.vue?vue&type=script&lang=js"
import style0 from "./DecisionAiCoachList.vue?vue&type=style&index=0&id=ae1e5f40&prod&lang=scss&scoped=true"
import style1 from "./DecisionAiCoachList.vue?vue&type=style&index=1&id=ae1e5f40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1e5f40",
  null
  
)

export default component.exports